import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
  class: "mb-4"
};
const _hoisted_2 = {
  class: "-mx-4"
};
const _hoisted_3 = {
  class: "flex-center px-6"
};
const _hoisted_4 = {
  class: "flex-center px-6"
};
import Modal from "@/modules/vue/components/Modal.vue";
import { Incident } from "@/modules/match/entity";
import StadiumLog from "@/modules/stadium/components/StadiumLog.vue";
import { Stadium } from "@/modules/stadium/entity";
import StadiumLogLoader from "@/modules/stadium/components/StadiumLogLoader.vue";
import MatchScore from "@/modules/match/components/MatchScore.vue";
import MatchIncidentList from "@/modules/match/components/MatchIncidentList.vue";
import MatchStats from "@/modules/match/components/MatchStats.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'MatchModal',
  props: {
    match: null
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    const modal = ref();
    const incidents = ref([]);
    const stadium = ref();
    const hide = () => modal.value.hide();
    const show = async () => {
      await props.match.load('stadiumLog');
      stadium.value = await Stadium.createQueryBuilder('stadium').innerJoinAndSelect('stadium.terraces', 'terrace').innerJoin('stadium.team', 'team').where('team.id = :id', {
        id: props.match.homeTeam.id
      }).getOneOrFail();
      incidents.value = await Incident.createQueryBuilder('incident').innerJoin('incident.match', 'match').leftJoinAndSelect('incident.team', 'team').leftJoinAndSelect('incident.player', 'player').where('match.id = :matchId', {
        matchId: props.match.id
      }).getMany();
      modal.value.show();
    };
    expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_NTabPane = _resolveComponent("NTabPane");
      const _component_NTabs = _resolveComponent("NTabs");
      return _openBlock(), _createBlock(Modal, {
        ref_key: "modal",
        ref: modal
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [__props.match.result ? (_openBlock(), _createBlock(StadiumLogLoader, {
          key: 0,
          match: __props.match,
          class: "mb-2 text-base"
        }, {
          default: _withCtx(({
            stadium,
            stadiumLog
          }) => [_createVNode(StadiumLog, {
            stadium: stadium,
            "stadium-log": stadiumLog
          }, null, 8, ["stadium", "stadium-log"])]),
          _: 1
        }, 8, ["match"])) : _createCommentVNode("", true), _createVNode(MatchScore, {
          match: __props.match
        }, null, 8, ["match"])]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_NTabs, {
          "default-value": "incidents",
          "justify-content": "space-evenly",
          type: "line"
        }, {
          default: _withCtx(() => [_createVNode(_component_NTabPane, {
            name: "incidents",
            tab: _ctx.$t('incidents')
          }, {
            tab: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_Icon, {
              icon: _ctx.IconEnum.MegaphoneLoud20Regular
            }, null, 8, ["icon"])])]),
            default: _withCtx(() => [_createVNode(MatchIncidentList, {
              match: __props.match,
              incidents: incidents.value
            }, null, 8, ["match", "incidents"])]),
            _: 1
          }, 8, ["tab"]), _createVNode(_component_NTabPane, {
            name: "stats"
          }, {
            tab: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_Icon, {
              icon: _ctx.IconEnum.ChartMultiple20Regular
            }, null, 8, ["icon"])])]),
            default: _withCtx(() => [_createVNode(MatchStats, {
              match: __props.match
            }, null, 8, ["match"])]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      }, 512);
    };
  }
});